import { Component, ComponentFactoryResolver, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConsoleService } from '@ng-select/ng-select/lib/console.service';
import { SectorTypeService } from '../../../../../app/shared/API-Service/services/sector-type.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { Image } from '../../../../../images/images'


@Component({
  selector: 'app-view-sector-type',
  templateUrl: './view-sector-type.component.html',
  styleUrls: ['./view-sector-type.component.css']
})
export class ViewSectorTypeComponent implements OnInit {
  sectortype:object [] = [];

  constructor(private _SectorTypeService:SectorTypeService,private _Router:Router) { }

  ngOnInit(): void {
    this.getsectortype();
  }
  getsectortype(){
    this._SectorTypeService.GetSectorType().subscribe((res) => {
      this.sectortype = res.data 
    },(err)=>{
      console.log('their is a problem');
    },() =>{
      console.log('Completed');
    });
  }
  update(data){
    this._SectorTypeService.Data.next(data);
    this._Router.navigate(['/content/admin/InsertSectorType']);
    }
    delete(id : number){
      Swal.fire({
        title: 'هل تريد مسح العنصر ؟',
        text: "لن يكون لك صلاحية إعادته مره اخرى",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'الغاء',
        confirmButtonText: 'امسح العنصر !'
      }).then((result) => {
        if (result.isConfirmed) {
          this._SectorTypeService.DeleteSectorType(id).subscribe((res) => {
            Swal.fire({
              icon: "success",
              title: "تم المسح بنجاح",
              showConfirmButton: false,
              timer: 1500,
            });
         this.getsectortype();
          },(err) => {
            Swal.fire({
              icon: 'error',
              title: 'خطأ',
              text:err.error.message    
            })
          },() => {
            console.log("completed");
          })
        }
      }) 
    }
}
